module.exports = __webpack_public_path__ + "img/main2.e7aaa66f.png";